/**
 * Created by toomasp on 31.08.2015.
 */
'use strict';
export let ngBlur:any[] = ['$parse', ($parse)=> {
    class NgBlurDirective {
        link(scope, element, attr) {
            var fn = $parse(attr['ngBlur']);
            element.bind('blur', function (event) {
                scope.$apply(function () {
                    fn(scope, {
                        $event: event
                    });
                });
            });
        }
    }
    return new NgBlurDirective();
}]


// WEBPACK FOOTER //
// ./src/main/ui/core/directives/decorator/ng-blur.directive.ts